// A door on the front page: what it is, and the one control that opens it.
//
// **Three doors, and only one of them unfolds at a time.** The menu grew a card
// every time single player did, and by the end the first thing a new player saw
// was four ways to start that all looked equally important. The card is the
// shape that keeps the choice down to three.
//
// A `Panel`, solid: the front door is a page rather than a surface over the
// board, so there is nothing behind it to let through.

import type { ReactNode } from "react";

import { Panel, Text, styled } from "../kit";

const Plate = styled(Panel)(({ theme }) => ({ padding: theme.kit.space.lg }));

const Row = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: theme.kit.space.lg
}));

const Title = styled("h2")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.kit.font.heading,
  fontWeight: 400,
  fontSize: 17,
  lineHeight: 1.1,
  color: theme.kit.color.ink
}));

/** A row of chips or a field, under the title. */
export const DoorBody = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.kit.space.sm,
  marginTop: theme.kit.space.md
}));

/** A row of controls inside a door. */
export const DoorRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.kit.space.sm,
  flexWrap: "wrap"
}));

export function DoorCard({
  title,
  detail,
  action,
  children
}: {
  title: string;
  detail: string;
  /** The button that opens it — never more than one. */
  action: ReactNode;
  children?: ReactNode;
}) {
  return (
    <Plate solid>
      <Row>
        <div>
          <Title>{title}</Title>
          <Text tone="dim" size={12.5} block style={{ marginTop: 3, lineHeight: 1.5 }}>
            {detail}
          </Text>
        </div>
        <div style={{ flexShrink: 0 }}>{action}</div>
      </Row>
      {children}
    </Plate>
  );
}
